import React from 'react'
import TenantConfigPanel from 'src/companies/configurations/tenant'

export default function MarketsConfig() {
  return (
    <TenantConfigPanel baseUri="/api/markets/aggregator/config/v1" title="Markets" alwaysExpanded />
  )
}
